import classNames from "classnames";
import PropTypes from "prop-types";
import ConversationList from "./conversation-list";
import "./collapsible-menu.scss";

const CollapsibleMenu = ({
  isVisible = false,
  sidebarCollapse = false,
  activeConversationID = null,
  agencyId,
  onDeleteActiveConversation,
}) => {
  return (
    <div
      className={classNames("collapsible-menu", {
        "collapsible-menu--visible": isVisible,
        "collapsible-menu--sidebar-collapsed": sidebarCollapse,
      })}
    >
      <div className="collapsible-menu__section">
        <ConversationList
          isVisible={isVisible}
          activeConversationID={activeConversationID}
          agencyId={agencyId}
          onSelectConversation={(id) => {
            window.dispatchEvent(
              new CustomEvent("backoffice-resume-chat", {
                detail: { conversationID: id },
              })
            );
          }}
          onDeleteActiveConversation={onDeleteActiveConversation}
        />
      </div>
    </div>
  );
};

CollapsibleMenu.propTypes = {
  isVisible: PropTypes.bool,
  sidebarCollapse: PropTypes.bool,
  activeConversationID: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf([null]),
  ]),
  agencyId: PropTypes.string,
  onDeleteActiveConversation: PropTypes.func,
};

export default CollapsibleMenu;
